let View = require('views/view')
let app = require('application')

module.exports = View.extend({
  template: require('views/templates/pays/pays'),
  events () { // On récupère ici les events de view (les event globaux) pis on ajoute les spécifiques a cette vue (SOURCE : http://stackoverflow.com/questions/9403675/backbone-view-inherit-and-extend-events-from-parent)
    return _.extend({}, View.prototype.events, {

    })
  },
  list () {
    let data = $('#form-pagination').serialize()
    this.hideFormEvent()

    $('#pays-list').html('<i class="fa fa-refresh fa-spin"></i> Chargement en cours...')

    app.ajax({
      url: '/pays',
      data,
      success: (...args) => this.refreshList(...args)
    })
  },
  refreshList (pays, status, xhr) {
    $('#pays-list').html(require('views/templates/pays/list')({
      pays,
      searchTerms: xhr.getResponseHeader('ps-search-term'),
      total: xhr.getResponseHeader('ps-total-row')
    })).show()

    app.initList()
  },
  update (e) {

  },
  showFormEvent (data) {
  },
  hideFormEvent (e) {
  },
  prepareFormEvent (e) {
  },
  processFormEvent (e) {

  },
  delete (e) {
  }

})
